// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// Why a certificate file didn't open. A small module of its own, so the
// dialog can tell the reasons apart without loading the crypto libraries.
import { CertificateOpenFailure } from "./types";
export var CertificateFileErrorCode;
(function (CertificateFileErrorCode) {
    /** Not a PKCS#12 file at all (PEM, truncated, random bytes). */
    CertificateFileErrorCode["UnreadableFile"] = "UNREADABLE_FILE";
    /** The MAC (integrity) check failed or, in a MAC-less file, decryption failed. */
    CertificateFileErrorCode["WrongPassword"] = "WRONG_PASSWORD";
    /** A PBE, MAC or cipher forge doesn't implement. */
    CertificateFileErrorCode["UnsupportedEncryption"] = "UNSUPPORTED_ENCRYPTION";
    CertificateFileErrorCode["NoPrivateKey"] = "NO_PRIVATE_KEY";
    CertificateFileErrorCode["NoCertificate"] = "NO_CERTIFICATE";
    /** The key is neither RSA nor EC P-256. */
    CertificateFileErrorCode["UnsupportedKey"] = "UNSUPPORTED_KEY";
    /** No certificate in the file matches its private key. */
    CertificateFileErrorCode["KeyCertificateMismatch"] = "KEY_CERTIFICATE_MISMATCH";
})(CertificateFileErrorCode || (CertificateFileErrorCode = {}));
var CertificateFileError = /** @class */ (function (_super) {
    __extends(CertificateFileError, _super);
    function CertificateFileError(code, message, options) {
        var _this = _super.call(this, message, options) || this;
        // The portal compiles to ES5, where an Error subclass loses its prototype: restore it
        // so `instanceof CertificateFileError` holds in the production build.
        Object.setPrototypeOf(_this, CertificateFileError.prototype);
        _this.name = "CertificateFileError";
        _this.code = code;
        return _this;
    }
    return CertificateFileError;
}(Error));
export { CertificateFileError };
/** The reason the open-failures route records (the file name and this only). */
export var openFailureReason = function (code) {
    switch (code) {
        case CertificateFileErrorCode.WrongPassword:
            return CertificateOpenFailure.WrongPassword;
        case CertificateFileErrorCode.NoPrivateKey:
            return CertificateOpenFailure.NoKey;
        default:
            return CertificateOpenFailure.Unreadable;
    }
};
